import iban from "iban";
export var formatIban = function (input) {
    if (!input) {
        return;
    }
    return iban.printFormat(input);
};
export var formatIbanWithoutSpaces = function (phone) {
    var parsed = formatIban(phone);
    if (!parsed) {
        return;
    }
    return parsed.replace(/ /g, "");
};
export var isValidIban = function (input) {
    if (!input) {
        return false;
    }
    return iban.isValid(input);
};
var OBFUSCATED_GROUP = "°°°°";
/**
 * Masks the middle groups of an IBAN, keeping the country/check-digits prefix
 * and the last group visible: "BE68 °°°° °°°° 7034".
 *
 * The input is grouped first, so it does not matter whether it arrives spaced -
 * as the V2 API sends it - or without spaces, as the V1 API did. Splitting the
 * raw value on spaces used to leave an IBAN without them untouched, showing it
 * in full.
 */
export var obfuscateIban = function (rawIban) {
    var _a;
    var groups = (_a = formatIban(rawIban)) === null || _a === void 0 ? void 0 : _a.split(" ");
    if (!groups) {
        return "";
    }
    return groups
        .map(function (group, index) {
        return index > 0 && index < groups.length - 1 ? OBFUSCATED_GROUP : group;
    })
        .join(" ");
};
